import React from 'react';

//* Styles
import CollapseItemStyle from './style';

const CollapseItem = ({ title, description, disable, status }) => {
	return (
		<CollapseItemStyle className='collapse-item-wrapper'>
			<div
				id={'collapse-item'}
				className={`${status == 'open' ? 'active' : ''}`}
				status={status || 'close'}
				disable={disable === false ? 'false' : disable && 'true'}
			>
				<div id='collapse-title'>{title}</div>

				<div id='collapse-description'>
					<div id='inner-wrapper-description'>{description}</div>
				</div>
			</div>
		</CollapseItemStyle>
	);
};

export default CollapseItem;
